'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidNotificationsOff = function IoAndroidNotificationsOff(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm20.2 36.3c-1.8 0-3.2-1.5-3.2-3.3h6.4c0 1.8-1.4 3.3-3.2 3.3z m-9.7-27.9l23.9 23.9-1.8 1.9-2.9-2.8h-23.2v-1.6l3.2-3.2v-9c0-1.8 0.4-3.5 1.2-4.9l-4.9-5 1.9-1.9 2.6 2.6z m20.3 9.2v7.3l-16.3-16.1c1-0.7 2.1-1.2 3.3-1.5v-1.1c0-1.4 1-2.5 2.4-2.5s2.4 1.1 2.4 2.5v1.1c4.6 1.1 8.2 5.3 8.2 10.3z' })
        )
    );
};

exports.default = IoAndroidNotificationsOff;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-notifications-off.js
// module id = 1884
// module chunks = 0